<template>
    <div class="modal fade" id="modal-edit-product" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
        data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-body p-4">
                    <div class="row mb-4">
                        <div class="col-12 text-end">
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-2 text-center">
                            <img class="img-thumbnail" width="100px" v-bind:src="productChosen.product_image"
                                productId="" alt="" />
                        </div>
                        <div class="col-6">
                            <p class="modal-title mb-0 fw-500 text-black" id="exampleModalLabel">
                                {{ productChosen.name }}
                            </p>
                            <p class="text-black-60">
                                {{ productChosen.default_unit_name }}
                            </p>
                            <p class="mb-0 fw-400">
                                ยี่ห้อ:
                                <span class="text-black-60"> {{ productChosen.brand }}</span>
                            </p>
                        </div>
                        <div class="col-4 text-end align-self-start">
                            <p class="mb-0 fw-400">ราคาสินค้า</p>
                            <h3 class="mb-0 fw-500 text-black">{{ productChosen.price }}</h3>
                            <p class="mb-0 fw-400">
                                คงเหลือในคลัง: {{ productChosen.remaining_amount }}
                            </p>
                            <p class="mb-0 fw-400">
                                <i class="si si-info" id="tooltip-step-price" data-bs-toggle="tooltip"
                                    data-bs-placement="left"></i>
                            </p>
                        </div>
                    </div>
                    <hr />
                    <div class="row p-2">
                        <div class="col-3 align-self-center">
                            <p class="mb-0 fw-400 text-black">แพ็กเกจ</p>
                        </div>
                        <div class="col-9 align-self-center" style="padding-left: 0px">
                            <div class="d-flex flex-row gap-1">
                                <div class="d-inline-block" @click="choosePackage(null)">
                                    <div class="form-check form-block">
                                        <input class="form-check-input custom-checkmark" type="radio"
                                            v-bind:value="null" name="product_package_id" v-bind:id="productChosen.id"
                                            v-bind:checked="productChosen.package.id == null" />
                                        <label class="form-check-label py-0" v-bind:for="productChosen.id">
                                            <p class="text-center" style="margin-bottom: 0; line-height: 34px">
                                                <span class="">{{ productChosen.unit_name }}</span>
                                            </p>
                                        </label>
                                    </div>
                                </div>
                                <div class="d-inline-block"
                                    v-for="(productpackage, index) in productChosen.productPackages" v-bind:key="index"
                                    @click="choosePackage(productpackage)">
                                    <div class="form-check form-block">
                                        <input class="form-check-input custom-checkmark" type="radio"
                                            v-bind:value="productpackage.id" v-bind:id="productpackage.id"
                                            name="product_package_id" v-bind:checked="productChosen.package.id == productpackage.id
                                                " />
                                        <label class="form-check-label py-0" v-bind:for="productpackage.id">
                                            <p class="text-center" style="margin-bottom: 0; line-height: 34px">
                                                <span class="">{{ productpackage.name }} ({{
                                                    productpackage.amount_per_unit
                                                    }})</span>
                                            </p>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row p-2">
                        <div class="col-3 align-self-center">
                            <p class="mb-0 fw-400 text-black">จำนวน</p>
                        </div>
                        <div class="col-5 align-self-center">
                            <div class="position-relative">
                                <div class="row mb-3 justify-content-evenly border rounded-3 p-1">
                                    <button id="decrease"
                                        class="col-2 btn-edit bg-light border rounded-circle align-self-center"
                                        type="button" @click="decrease">
                                        <i class="fa fa-minus p-0 btn-edit-icon"></i>
                                    </button>
                                    <input tabindex="0"
                                        class="col-4 input-1 text-center rounded mb-0 fs-5 input-banknote btn"
                                        style="border: 0px" value="0" readonly role="button" data-bs-toggle="popover"
                                        data-bs-trigger="focus" data-bs-custom-class="bg-white" v-model="inputValue"
                                        @click="toggleNumberKeyBoard()" />
                                    <button id="increase"
                                        class="col-2 btn-edit bg-light border rounded-circle align-self-center"
                                        type="button" @click="increase">
                                        <i class="fa fa-plus p-0 btn-edit-icon"></i>
                                    </button>
                                    <number-keyboard ref="numberKeyboard" @setAmount="setAmount"
                                        @close="closeNumberKeyboard"></number-keyboard>
                                </div>
                            </div>
                        </div>
                        <div class="col-4"></div>
                    </div>
                    <div class="row p-2">
                        <div class="col-3 align-self-center">
                            <p class="mb-0 fw-400 text-black">เพิ่มจำนวนแบบรวดเร็ว</p>
                        </div>
                        <div class="col-6 align-self-center" style="padding-left: 0px">
                            <div class="row">
                                <div class="col-4">
                                    <button class="btn btn-light w-100" @click="addQty(20)">
                                        +20
                                    </button>
                                </div>
                                <div class="col-4">
                                    <button class="btn btn-light w-100" @click="addQty(50)">
                                        +50
                                    </button>
                                </div>
                                <div class="col-4">
                                    <button class="btn btn-light w-100" @click="addQty(100)">
                                        +100
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-3"></div>
                    </div>
                    <div class="row p-2" v-if="is_can_edit_price">
                        <div class="col-3 align-self-center">
                            <p class="mb-0 fw-400 text-black">ราคาสินค้า</p>
                        </div>
                        <div class="col-6 align-self-center" style="padding-left: 0px">
                            <div class="row">
                                <div class="col-12">
                                    <div class="input-group">
                                        <input type="number" class="form-control text-end" placeholder="0.00" required
                                            v-model="productChosen.custom_price"
                                            v-bind:disabled="!productChosen.enabled_custom_price" />
                                        <div class="input-group-text">
                                            <input class="form-check-input mt-0" type="checkbox" value=""
                                                aria-label="Checkbox for following text input"
                                                v-model="productChosen.enabled_custom_price" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-3"></div>
                    </div>
                    <div class="row p-2">
                        <div class="col-3 align-self-center">
                            <p class="mb-0 fw-400 text-black">ล็อตสินค้า</p>
                        </div>
                        <div class="col-6 align-self-center" style="padding-left: 0px">
                            <div class="row">
                                <div class="col-12" v-if="productChosen.index >= 0">
                                    <tree-select :options="stockTransactions" name="stock_trasaction_id"
                                        v-on:open="getStockTransactions(productChosen.index)"
                                        :value="textStockTransaction"
                                        v-on:tree-select="(value) => selectStockTransaction(value)"
                                        ref="stock_transaction"></tree-select>
                                </div>
                            </div>
                        </div>
                        <div class="col-3"></div>
                    </div>
                    <div class="row p-2">
                        <div class="col-3 align-self-center">
                            <p class="mb-0 fw-400 text-black">รายละเอียดล็อตสินค้า</p>
                        </div>
                        <div class="col-6 align-self-center" style="padding-left: 0px">
                            <div class="row">
                                <div class="col-12" v-if="productChosen.index >= 0">
                                    <span v-html="stockTransactionDetail"></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-3"></div>
                    </div>
                    <div class="row p-2" v-if="is_can_see_cost">
                        <div class="col-3 align-self-center">
                            <p class="mb-0 fw-400 text-black">ต้นทุน</p>
                        </div>
                        <div class="col-6 align-self-center" style="padding-left: 0px">
                            <div class="row">
                                <div class="col-12">
                                    <p class="mb-0" v-if="productChosen.package.amount_per_unit">
                                        {{ productChosen.cost_average_latest * productChosen.package.amount_per_unit }} บาท /
                                        {{ productChosen.package.name }}
                                    </p>
                                    <p class="mb-0" v-else>
                                        {{ productChosen.cost_average_latest }} บาท /
                                        {{ productChosen.unit_name }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-3"></div>
                    </div>
                    <hr />
                    <div class="row p-2">
                        <div class="col-12">
                            <p class="mb-0 fw-bold">รายละเอียดสินค้า</p>
                        </div>
                        <div class="col-12">
                            <p>-----------------------</p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-8">
                            <button class="btn btn-danger px-3 py-2" @click="deleteItem()">
                                <i class="far fa-trash-alt"></i>
                            </button>
                        </div>
                        <div class="col-4 text-end">
                            <button class="btn btn-primary px-5 py-2 w-100" @click="updateAmount()">
                                อัปเดท
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "modal-edit-product",
    props: ["cart", "cartDetails", "urlGetProductDetail", 'urlGetStockTransactions', 'is_can_edit_price', 'is_can_see_cost'],
    data() {
        return {
            productChosen: {
                index: "",
                id: "",
                name: "",
                brand: "",
                unit_name: "",
                package: {
                    id: "",
                    name: "",
                },
                price: 0,
                stock: 0,
                amount: 0,
                productPackages: [],
                custom_price: 0,
                enabled_custom_price: false,
            },
            inputValue: 1,
            stockTransactions: [],
            stockTransactionId: null,
            textStockTransaction: "",
            stockTransactionDetail: "-"
        };
    },
    methods: {
        choosePackage(productPackage) {
            if (productPackage) {
                this.productChosen.package.id = productPackage.id;
                this.productChosen.package.name = productPackage.name;
                this.productChosen.package.amount_per_unit =
                    productPackage.amount_per_unit;
                this.productChosen.package.package_price = productPackage.package_price;
                this.productChosen.price = productPackage.package_price;
                this.productChosen.default_unit_name = productPackage.name;
            } else {
                this.productChosen.package.id = null;
                this.productChosen.package.name = null;
                this.productChosen.package.amount_per_unit = null;
                this.productChosen.package.package_price = null;
                this.productChosen.price = this.productChosen.retail_price;
                this.productChosen.default_unit_name = this.productChosen.unit_name;
            }
        },
        deleteItem() {
            let index = this.productChosen.index;
            this.$emit("delete", index);
            $("#modal-edit-product").modal("hide");
        },
        updateAmount() {
            let index = this.productChosen.index;
            if (this.inputValue <= 0) {
                mySwal.fire({
                    title: "ไม่สามารถอัปเดตสินค้าได้",
                    text: `จำนวนสินค้าต้องมีค่ามากกว่า 0`,
                    icon: "error",
                });
                return;
            }
            if (this.cart.length > index) {
                let price = this.cart[index].retail_price;
                let enabled_custom_price = false;
                if (this.productChosen.custom_price) {
                    price = this.productChosen.custom_price;
                }
                if (this.productChosen.enabled_custom_price) {
                    enabled_custom_price = true;
                }

                let product_package_id = this.productChosen.package.id;
                let amount = this.inputValue;
                this.$emit("confirm", {
                    price: price,
                    enabled_custom_price,
                    product_package_id,
                    amount,
                    index,
                    stock_transaction_id: this.stockTransactionId
                });
            }
            $("#modal-edit-product").modal("hide");
        },
        addQty(amount) {
            this.inputValue = parseInt(this.inputValue) + parseInt(amount);
        },
        setAmount(amount) {
            this.inputValue = amount;
        },
        toggleNumberKeyBoard() {
            this.$refs.numberKeyboard.setIsOpen(
                !this.$refs.numberKeyboard.getIsOpen()
            );
        },
        decrease() {
            if (this.inputValue > 0) {
                this.inputValue--;
                this.calculate();
            }
        },
        increase() {
            this.inputValue++;
            this.calculate();
        },
        closeNumberKeyboard() {
            this.calculate();
        },
        calculate() {
            let price;
            //   console.log(this.amount_per_unit);
            if (
                this.productChosen.step_prices &&
                this.productChosen.step_prices.length > 0
            ) {
                let step_prices = this.productChosen.step_prices
                    .slice()
                    .sort()
                    .reverse(); // high to low
                let amount_per_unit = this.productChosen.package.amount_per_unit;
                let unit_price = this.productChosen.retail_price;
                for (let index = 0; index < step_prices.length; index++) {
                    if (amount_per_unit) {
                        if (
                            this.inputValue * amount_per_unit >=
                            step_prices[index].step_amount
                        ) {
                            price = step_prices[index].step_price * amount_per_unit;
                        }
                    } else {
                        if (this.inputValue >= step_prices[index].step_amount) {
                            price = step_prices[index].step_price;
                        }
                    }
                    if (!amount_per_unit) {
                        if (
                            this.inputValue < step_prices[step_prices.length - 1].step_amount
                        ) {
                            price = unit_price;
                        }
                    }
                    if (price) {
                        this.productChosen.price = parseFloat(price).toFixed(4);
                        break;
                    }
                }
            }
        },
        setStockTransaction(i) {
            this.textStockTransaction = "Loading..."
            this.stockTransactionDetail = "Loading..."
            this.stockTransactionId = this.cart[i].stock_transaction_id;
            if (this.cart[i].stock_transaction_id) {
                this.textStockTransaction = `วันหมดอายุ: ${this.cart[i].expiry_date} ล๊อต: ${this.cart[i].manufacturing_no}`
                this.getStockDetail(this.cart[i].stock_transaction_id)
            } else {
                this.stockTransactionDetail = '-'
                this.textStockTransaction = "ไม่ได้เลือกล๊อต"
            }
        },
        async start(i) {
            this.setStockTransaction(i)
            let current_cart = this.cart;
            let cart_details = this.cartDetails;
            let data = {
                index: i,
                current_cart,
                cart_details,
            };
            let res = null;
            try {
                res = await axios.post(this.urlGetProductDetail, data);
            } catch (error) {
                errorPos();
                return;
            }
            this.productChosen.id = res.data.product.id;
            this.productChosen.index = res.data.index;
            this.productChosen.product_image = res.data.product_image;
            this.productChosen.name = res.data.product.name;
            this.productChosen.unit_name = res.data.product.unit_name;
            this.productChosen.default_unit_name = res.data.default_unit_name;
            this.productChosen.brand = res.data.brand_name;
            this.productChosen.price = res.data.price;
            this.productChosen.retail_price = res.data.retail_price;
            this.productChosen.amount = res.data.amount;
            this.productChosen.productPackages = res.data.product_packages;
            this.productChosen.package.id = res.data.product_package_id;
            this.productChosen.package.amount_per_unit = res.data.amount_per_unit;
            this.productChosen.enabled_custom_price = res.data.enabled_custom_price;
            this.productChosen.cost_average = res.data.cost_average;
            this.productChosen.cost_average_latest = res.data.cost_average_latest;
            this.productChosen.step_prices = res.data.step_price_info;
            this.productChosen.remaining_amount = res.data.remaining_amount;
            this.productChosen.step_price_info = res.data.step_price_info;

            if (this.productChosen.package.id == null) {
                this.productChosen.package.name = null;
                this.productChosen.package.amount_per_unit = null;
                this.productChosen.package.package_price = null;
                this.productChosen.price = res.data.retail_price;
            }

            if (!res.data.enabled_custom_price) {
                this.productChosen.custom_price = 0;
            } else {
                this.productChosen.custom_price = res.data.custom_price;
            }

            this.inputValue = res.data.amount;

            var elToolTip = document.getElementById("tooltip-step-price");
            var tooltip = new bootstrap.Tooltip(elToolTip, {
                title: res.data.tooltip_step_price,
                html: true,
            });
        },
        async getStockTransactions(i) {
            let res = await axios.get(this.urlGetStockTransactions, {
                params: {
                    product_id: this.cart[i].product_id,
                }
            })
            if (res.data.success) {
                let data = res.data.result.map(item => {
                    item.label = item.text;
                    return item
                });
                this.stockTransactions = data;
                this.$refs.stock_transaction.options_data = data;
                this.$refs.stock_transaction.selected_data = null;
                this.$refs.stock_transaction.$forceUpdate()
            }

        },
        selectStockTransaction(value) {
            this.stockTransactionId = value.id
            this.getStockDetail(value.id)
        },
        async getStockDetail(id) {
            let res = await axios.get("/pos-cart/get-stock-transaction-detail", {
                params: {
                    stock_transaction_id: id
                }
            })
            if (res.data.success) {
                let result = res.data.result;
                this.stockTransactionDetail = `
                        ล๊อต : ${result.manufacturing_no ? result.manufacturing_no : '-'} วันหมดอายุ : ${result.expiry_date ? result.expiry_date : '-'} <br>
                        เลขที่บิล : ${result.bill_no ? result.bill_no : '-'} <br>
                        คลัง : ${result.warehouse ? result.warehouse : '-'}
                    `;
            }
        }
    },
};
</script>
